module.exports = __webpack_public_path__ + "img/buscar.f1b93965.svg";